<template>
	<module-tab name="退款单" enable-flex @mounted="$refs.search.search()" @activated="$refs.table.update()">
		<m-search ref="search" @search="searchHandle">
			<m-search-item label="退款单号">
				<c-input name="refund_number"></c-input>
			</m-search-item>
			<m-search-item label="订单号">
				<c-input name="order_number"></c-input>
			</m-search-item>
			<m-search-item label="申请时间" colspan="2">
				<c-datetime start-name="start_date" end-name="end_date" range></c-datetime>
			</m-search-item>
			<m-search-item label="退款状态" colspan="2">
				<c-checkbox-group name="state" :options="stateOptions"></c-checkbox-group>
			</m-search-item>
		</m-search>
        <m-operate>
            <c-button color="m" hollow @click="syncExport()">导出</c-button>
        </m-operate>
		<c-table ref="table" height="grow">
			<c-table-column
				width="400"
			>
				<template slot="head">
					<span style="margin-left: 15px;">退款商品信息</span>
				</template>
			</c-table-column>
			
			<c-table-column
				label="申请数量"
				width="130"
				align-center
			></c-table-column>
			
			<c-table-column
				label="申请金额"
				width="130"
				align-center
			></c-table-column>
			
			<c-table-column
				label="退款状态"
				width="170"
				align-center
			></c-table-column>
			
			<c-table-column
				label="操作"
				width="170"
				align-center
			></c-table-column>
			
			<template #custom="{data}">
				<div :key="data.id" class="order">
					<div class="order-head flex-between-center">
						<div class="flex-center">
							<!-- <c-checkbox></c-checkbox> -->
							<span class="number">退款单号：{{data.refund_number}}
                                <span v-if="data.refund_type==4">
                                    【纠纷退款】
                                </span>
                            </span>

							<p class="info">关联订单号：
                                <c-link @click="navigateTo(`/order_detail/${data.order_number}`)">
                                    {{data.order_number}}
                                </c-link>
                            </p>
							<p class="info">申请时间：{{data.create_date}}</p>
                            <p v-if="data.operation_mode == 2">
                                买家：{{data.nick_name||data.receiving_name}}
                            </p>
                        </div>
					</div>
					<div class="flex">
						<div class="order-product">
							<div v-for="(sku, i) in data.product_sku_list" :key="i" class="sku flex-center">
								<c-file class="sku-image" :src="sku.product_img_url" media></c-file>
								<div class="flex-grow">
                                    <p class="sku-name ellipsis">
                                        <span v-if="sku.product_itemnumber">{{sku.product_itemnumber}} - </span>
                                        {{sku.product_name}}
                                    </p>
									<p class="sku-spec">退款原因：{{data.refund_reason||'-'}}</p>
								</div>
							</div>
						</div>
						<div class="order-sum flex-column flex-center">{{data.product_count}}</div>
						<div class="order-sum flex-column flex-center">￥{{data.refund_total_money}}</div>
						<div class="order-state flex-column flex-center">
                            <span v-if="data.state==1" style="color:blue">{{refundStateName[data.state]}}</span>
                            <span v-else-if="data.state==2" style="color:green">{{refundStateName[data.state]}}</span>
                            <span v-else-if="data.state==3" style="color:red">{{refundStateName[data.state]}}</span>
                            <span v-else-if="data.state==4" style="color:gray">{{refundStateName[data.state]}}</span>
                        </div>
						<div class="order-handle flex-column flex-center">
							<c-button power="b_refund_info_detail" @click="navigateTo({path: `/after_sale_detail/refund/${data.refund_number}`, query: {refundType: data.refund_type}})">查看详情</c-button>
						</div>
					</div>
				</div>
			</template>
		</c-table>
	</module-tab>
</template>

<script>
	export default {
		props: {
			state: String
		},
		
		data() {
			return {
                workType:19,
                searchParams:{},
                stateOptions: [
                    {name: '待审核',value:1},
                    {name: '审核通过',value:2},
                    {name: '已驳回',value:3},
                    {name: '已撤销',value:4}
                ],
                refundStateName: {
                    1: '待审核',
                    2: '审核通过',
                    3: '已驳回',
                    4: '已撤销'
                }
			}
		},
		
		computed: {
		},
			
		mounted() {
			this.$refs.search.set({
				state: this.state
			});
		},
		
		methods: {
			searchHandle(data) {
				this.$refs.table.load({
					url: '/refund/detail_list',
					data
				});
                this.searchParams = data;
			},

            /**同步导出数据**/
            syncExport(){
                this.request({
                    url: '/export/url',
                    data: Object.assign({
                        work_type: this.workType //业务类型
                    },this.searchParams),
                    success: data => {
                        this.download({
                            fileName: data.filename,
                            url: data.url,
                            loading: {
                                message: '数据文件生成中...'
                            }
                        })
                    }
                });
            }
		}
	}
</script>

<style>
</style>